import React, { useState, useEffect, useContext } from 'react';
import { Card, Steps, Button, message } from 'antd';
import { ClienteSelector } from './clienteSelector';
import { ArticuloSelector } from './articuloSelector';
import { ArticuloPosiciones } from './articuloPosiciones';
import { ResumenMovimientos } from './resumenMovimiento';
import { MovimientosProvider, useMovimientos } from '../../context/movimientosContext';
import { LoginContext } from '../../context/loginContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const { Step } = Steps;

const Inner = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [usuarios, setUsuarios] = useState([]);
  const { articulosMovimientos } = useMovimientos();
  const { user } = useContext(LoginContext);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/usuarios/clientes`, {
          headers: { Authorization: `Bearer ${user.token}` },
        });
        setUsuarios(data);
      } catch {
        message.error('Error al cargar los clientes');
      }
    })();
  }, [user]);

  const handleFinish = () => navigate('/posiciones');

  const steps = [
    { title: 'Cliente', content: <ClienteSelector usuarios={usuarios} /> },
    {
      title: 'Artículos y Posiciones',
      content: (
        <>
          <ArticuloSelector />
          {articulosMovimientos.map(item => (
            <ArticuloPosiciones key={item.articulo._id} articulo={item.articulo} />
          ))}
        </>
      )
    },
    { title: 'Resumen', content: <ResumenMovimientos onFinish={handleFinish} /> }
  ];

  return (
    <Card>
      <Steps current={currentStep}>
        {steps.map(s => <Step key={s.title} title={s.title} />)}
      </Steps>

      <div style={{ marginTop: 24 }}>{steps[currentStep].content}</div>

      <div style={{ marginTop: 24 }}>
        {currentStep > 0 && (
          <Button style={{ margin: '0 8px' }} onClick={() => setCurrentStep(s => s - 1)}>
            Anterior
          </Button>
        )}
        {currentStep < steps.length - 1 && (
          <Button type="primary" onClick={() => setCurrentStep(s => s + 1)}>
            Siguiente
          </Button>
        )}
      </div>
    </Card>
  );
};

export const CEntradaXArticulo = () => (
  <MovimientosProvider>
    <Inner />
  </MovimientosProvider>
);

export default CEntradaXArticulo;